(() => {
  const root = document.querySelector('.bb-funnel');
  if (!root) return;
  root.querySelectorAll('.bx-faq-list details').forEach(item => {
    item.addEventListener('toggle', () => {
      if (item.open) root.querySelectorAll('.bx-faq-list details[open]').forEach(other => { if (other !== item) other.open = false; });
    });
  });
  const enrich = () => {
    document.querySelectorAll('._rsi-quantity-offers-offer-container').forEach(offer => {
      const title = offer.querySelector('._rsi-quantity-offers-title');
      if (!title || title.querySelector('.bb-modal-copy')) return;
      const quantity = Number(title.textContent.match(/\d+/)?.[0]);
      const copy = root.getAttribute('data-bb-copy' + quantity);
      if (!copy) return;
      const extra = document.createElement('span');
      extra.className = 'bb-modal-copy';
      extra.textContent = copy;
      title.append(extra);
      const image = offer.querySelector('._rsi-modal-line-item-image');
      const source = root.getAttribute('data-bb-image' + quantity);
      if (image && source) image.src = source + (source.includes('?') ? '&' : '?') + 'quality=78&width=200';
    });
  };
  let scheduled = false;
  const observer = new MutationObserver(records => {
    const relevant = records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('._rsi-quantity-offers-offer-container') || node.querySelector('._rsi-quantity-offers-offer-container'))));
    if (!relevant || scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; enrich(); });
  });
  observer.observe(document.body, {childList:true,subtree:true});
  enrich();
})();

(() => {
  const active = document.querySelector('.mc-today-offer');
  if (!active) return;
  const zone = 'America/Santiago';
  const dayFormat = new Intl.DateTimeFormat('en-CA',{timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit'});
  const dateFormat = new Intl.DateTimeFormat('es-CL',{timeZone:zone,day:'numeric',month:'long'});
  const getDay = time => dayFormat.format(new Date(time));
  // Find the actual next date boundary, including Chile's DST transitions.
  const nextBoundary = now => {
    const day = getDay(now);
    let low = Math.floor(now / 1000) * 1000, high = low + 27 * 3600000;
    while (high - low > 1000) {
      const mid = Math.floor((low + high) / 2000) * 1000;
      if (getDay(mid) === day) low = mid; else high = mid;
    }
    return high;
  };
  const fields = ['hours','minutes','seconds'].map(unit=>active.querySelector('[data-bb-'+unit+'],[data-tf-'+unit+']'));
  let currentDay = '', boundary = 0, timer;
  const paint = () => {
    const now = Date.now(), day = getDay(now);
    if (day !== currentDay || now >= boundary) {
      currentDay = day;
      boundary = nextBoundary(now);
      const label = active.querySelector('.mc-today-top > span:last-child');
      if (label) label.textContent = dateFormat.format(new Date(now)) + ' · Chile';
    }
    document.documentElement.classList.remove('bx-offer-expired','tf-offer-expired');
    active.hidden = false;
    document.querySelectorAll('.mc-today-ended').forEach(el=>el.hidden=true);
    const seconds = Math.max(0,Math.ceil((boundary-now)/1000));
    [Math.floor(seconds/3600),Math.floor(seconds/60)%60,seconds%60].forEach((value,index)=>{
      const text=String(value).padStart(2,'0');
      if(fields[index]&&fields[index].textContent!==text) fields[index].textContent=text;
    });
  };
  const resume = () => {clearInterval(timer);paint();if(!document.hidden)timer=setInterval(paint,1000);};
  document.addEventListener('visibilitychange',resume);
  window.addEventListener('pageshow',resume);
  resume();
})();
